import React from 'react';
import { HomeIcon, FolderIcon } from '@heroicons/react/24/solid';
import SharedNavbarBottom from 'shared_items/NavbarBottom';

const TABS = [
  { key: 'overview', label: 'Overview', Icon: HomeIcon },
  { key: 'explorer', label: 'Files', Icon: FolderIcon },
];

const NavbarBottom = ({ activeTab, handleTabChange }) => (
  <SharedNavbarBottom
    tabs={TABS}
    activeTab={activeTab}
    onTabChange={handleTabChange}
    moduleKey="identity"
    zIndexClass="z-40"
  />
);

export default NavbarBottom;
